import React, { useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Vigenere() {
  const [text, setText] = useState("");
  const [code, setCode] = useState("");
  const [pass, setPass] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const cleanTextInput = (v) => (v || "").toUpperCase().replace(/[^A-ZÑ ]/g, "");
  const cleanKeyForVigenere = (k) => (k || "").toUpperCase().replace(/[^A-Z]/g, "");
  const countEncryptable = (s) => ((s.match(/[A-Z]/g) || []).length);

  const prepareKey = (key, length) => {
    if (!key) return "";
    return key.repeat(Math.ceil(length / key.length)).substring(0, length);
  };

  const textToCodeStr = (textoRaw, passRaw) => {
    const texto = cleanTextInput(textoRaw);
    const key = cleanKeyForVigenere(passRaw);
    if (!key) return texto;

    const n = countEncryptable(texto);
    const nuevaClave = prepareKey(key, n);

    let result = "";
    let j = 0;
    for (let i = 0; i < texto.length; i++) {
      const ch = texto[i];
      if (ch === " ") {
        result += " ";
      } else if (ch === "Ñ") {
        result += "Ñ";
      } else {
        const charCodeText = texto.charCodeAt(i) - 65; // A -> 0
        const charCodeClave = nuevaClave.charCodeAt(j) - 65;
        result += String.fromCharCode(((charCodeText + charCodeClave) % 26) + 65);
        j++;
      }
    }
    return result;
  };

  const codeToTextStr = (cipherRaw, passRaw) => {
    const textoCifrado = cleanTextInput(cipherRaw);
    const key = cleanKeyForVigenere(passRaw);
    if (!key) return textoCifrado;

    const n = countEncryptable(textoCifrado);
    const nuevaClave = prepareKey(key, n);

    let result = "";
    let j = 0;
    for (let i = 0; i < textoCifrado.length; i++) {
      const ch = textoCifrado[i];
      if (ch === " ") {
        result += " ";
      } else if (ch === "Ñ") {
        result += "Ñ";
      } else {
        const charCodeText = textoCifrado.charCodeAt(i) - 65;
        const charCodeClave = nuevaClave.charCodeAt(j) - 65;
        result += String.fromCharCode(((charCodeText - charCodeClave + 26) % 26) + 65);
        j++;
      }
    }
    return result;
  };

  const handleTextChange = (e) => {
    const clean = cleanTextInput(e.target.value);
    setText(clean);
    if (pass) setCode(textToCodeStr(clean, pass));
    setShowAlert(false);
  };

  const handleCodeChange = (e) => {
    const clean = cleanTextInput(e.target.value);
    setCode(clean);
    if (pass) setText(codeToTextStr(clean, pass));
    setShowAlert(false);
  };

  const handlePassChange = (e) => {
    const raw = e.target.value.toUpperCase().replace(/[^A-ZÑ ]/g, "");
    setPass(raw);
    if (raw && text && code) setShowAlert(true);
  };

  const handleEncryptClick = () => {
    setCode(textToCodeStr(text, pass));
    setShowAlert(false);
  };
  const handleDecryptClick = () => {
    setText(codeToTextStr(code, pass));
    setShowAlert(false);
  };

  return (
  <>
    <HelmetProvider>
      <Helmet>
        <title>Vigenère | ERI</title>
      </Helmet>
    </HelmetProvider>
    <div id="ciphers" className="content">
      <div id="vigenere" className="content-wrapper">
        <div className="content-title">
          <h1 className="title">Vigenère</h1>
          <p className="subtitle">El cifrado Vigenère es un cifrado de sustitución simple polialfabético que utiliza una clave.</p>
        </div>
        <div className="content-main">
          <div className="content-code">
            <div className="content-encrypt">
              <label className="text-left" htmlFor="input-code">Código</label>
              <textarea id="input-code" className="input-left" name="code" value={code} spellCheck="false" onChange={handleCodeChange}/>
              <span className="info info-left">Carácteres permitidos: Letras y espacio</span>
              <div className="option">
                <label className="text-pass" htmlFor="input-pass">Clave</label>
              </div>
              <div className="buttons">
                <input id="input-pass" className="input-pass" name="pass" type="text" placeholder="Letras y espacio" value={pass} onChange={handlePassChange} />
                <button className="btn btn-primary" onClick={handleDecryptClick}><span>Cifrar </span><i className="fas fa-arrow-right" /></button>
                <button className="btn btn-primary" onClick={handleEncryptClick}><i className="fas fa-arrow-left" /><span> Descrifrar</span></button>
              </div>
              <div className="alert">
                <span className={`text-alert${showAlert ? " show" : ""}`}>Clave modificada, ¡cifrar o descifrar de nuevo!</span>
              </div>
              <label className="text-right" htmlFor="input-text">Texto</label>
              <textarea id="input-text" className="input-right" name="text" value={text} spellCheck="false" onChange={handleTextChange} />
              <span className="info info-right">Carácteres permitidos: Letras y espacio</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  );
}